import { IThemeCreationOptions } from '@/contexts/styles/ThemeActionContext';
import { responsiveFontSizes } from '@mui/material/styles';

const DefaultAfterThemeCreated: IThemeCreationOptions['afterThemeCreated'] = (theme, _chosenTheme) => {
    return responsiveFontSizes(theme);
};

export default DefaultAfterThemeCreated;